import { useState } from "react"
import { useAuth } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { loginApi } from "../../api/apiUrlConst";
import { Button, Card, Form, FormGroup, Input, Label } from "reactstrap";
export const LoginPage: React.FC = () => {
    const [mail, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);

    const { login } = useAuth();
    const navigate = useNavigate();

    const handleLogin = async (e: React.FormEvent) => {
        e.preventDefault();

        try {
            const {
                token,
                role,
                userId,
                name,
                email,
                phoneNumber,
                gender, } = await loginApi(mail, password);

            login(token, role, userId, name, email, phoneNumber, gender);

            if (role === 'Admin') navigate('/admin/dashboard');
            else navigate('/coordinator/dashboard');
        } catch (error: any) {
   if (!error.response) {
      toast.error("API not working. Please try again later.");
   } else {
      toast.error(error.response.data?.message || "Login failed");
   }
}
    }

   return (
  <div
  style={{
    minHeight: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "linear-gradient(135deg,#374151, #093d92)",
    padding: "20px",
  }}
>
  <Card
    className="shadow-lg border-0"
    style={{
      width: "100%",
      maxWidth: "420px",
      borderRadius: "20px",
      background: "rgba(255, 255, 255, 0.95)",
      backdropFilter: "blur(10px)",
    }}
  >
    <div className="p-5">

      {/* Logo / Title */}
      <div className="text-center mb-4">
        <h2 style={{ fontWeight: "700", color: "#333" }}>
          Welcome Back 👋
        </h2>
        <p style={{ color: "#777", marginBottom: 0 }}>
          Login to continue
        </p>
      </div>

      <Form onSubmit={handleLogin} className="d-flex flex-column gap-4">

        <FormGroup>
          <Label className="fw-semibold">Email Address</Label>
          <Input
            type="email"
            placeholder="abc@domain.com"
            value={mail}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="rounded-pill px-3 py-2 shadow-sm"
            style={{ height: "45px" }}
          />
        </FormGroup>
<FormGroup>
  <Label className="fw-semibold">Password</Label>

  <div className="position-relative">

    <Input
      type={showPassword ? "text" : "password"}
      placeholder="Enter password"
      value={password}
      onChange={(e) => setPassword(e.target.value)}
      required
      className="rounded-pill px-3 shadow-sm pe-5"
      style={{ height: "45px" }}
    />

    {/* 👁 Toggle Icon */}
    <span
      onClick={() => setShowPassword(!showPassword)}
      style={{
        position: "absolute",
        top: "50%",
        right: "15px",
        transform: "translateY(-50%)",
        cursor: "pointer",
        fontSize: "18px",
        color: showPassword ? "#0d6efd" : "#6c757d",
        transition: "0.2s",
      }}
    >
      {showPassword ? "🙈" : "👁"}
    </span>

  </div>
</FormGroup>

        <Button
          type="submit"
          className="w-100 mt-2"
          style={{
            background: "linear-gradient(90deg, #374151, #093d92)",
            border: "none",
            borderRadius: "30px",
            padding: "12px",
            fontWeight: "600",
            fontSize: "16px",
            transition: "0.3s",
          }}
        >
          Login
        </Button>

      </Form>

      {/* Footer */}
      <div className="text-center mt-4" style={{ fontSize: "14px" }}>
       <span style={{ color: "#777" }}>
  © {new Date().getFullYear()} Wocons Private Limited
</span>
      </div>

    </div>
  </Card>
</div>
);


}